import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getBackgrounds = (state: RootState) => state.pages.editor.backgrounds.list;

const getAllBackgrounds = createSelector([getBackgrounds], (backgrounds) => backgrounds);

export default getAllBackgrounds;
